import ComponentHelper from '../../supers/ComponentHelper';
import Modal from 'react-modal';
import React from 'react';
import './clone-modal.css';
import InputField from '../input-field/InputField';
import ValidationService from '../../services/ValidationService';
const VS = new ValidationService();

class CloneModal extends ComponentHelper {
	constructor(props) {
		super(props);
		this.setInitialData(props);
		this.autoBindAll(this);
	}

	setInitialData(props) {
		this.data = {
			title: props.title,
			name: props.toClone.name + '-clone'
		};
	}

	// Clear component state when modal is re-open
	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.setInitialData(nextProps);
			});
		}
	}

	handleNameChange(evt) {
		if (!VS.validateName(evt.target.value)) {
			return;
		}
		this.setData('name', evt.target.value);
	}

	cloneEndpoint() {
		this.props.cloneObject(this.data.name);
	}

	render() {
		let { isOpen } = this.props;
		let { title, name } = this.data;
		return (
			<Modal
				contentLabel="Modal"
				ariaHideApp={false}
				isOpen={isOpen}
				className="add-tenant-modal animated zoomIn"
				overlayClassName="dialog-modal-overlay vbox hcenter vcenter"
			>
				<div className="modal-header">{title}</div>
				<div className="modal-body">
					<InputField
						handleChange={this.handleNameChange}
						name="name"
						label="Endpoint Clone Name"
						type="text"
						required
						autoFocus={true}
						value={name}
					/>
				</div>
				<div className="btn-ctn">
					<button className="btn cancel-btn" onClick={this.props.onCancel}>
						Cancel
					</button>
					<button className="btn primary" onClick={this.cloneEndpoint} disabled={this.data.name.length <= 0}>
						Clone
					</button>
				</div>
			</Modal>
		);
	}
}
export default CloneModal;



// WEBPACK FOOTER //
// ./src/components/clone-modal/CloneModal.js